import React from "react";
import { useParams } from "react-router-dom";
import { TargetDetail } from "./cluster/TargetDetail";

export default function ClusterDetail() {
  const { id } = useParams();
  return <TargetDetail clusterId={id} kind="cluster" />;
}
